import React from "react";
import { DineInBoardStatsData } from "./dineInBoardBuilder";
import "./styles/DineInBoardStats.css";

interface DineInBoardStatsProps {
  stats: DineInBoardStatsData;
}

/**
 * The three-number strip above the grid. "Needs action" is highlighted only
 * when it's non-zero — a permanently amber zero trains staff to ignore the
 * colour, which is the one thing this strip exists to make them notice.
 */
const DineInBoardStats: React.FC<DineInBoardStatsProps> = ({ stats }) => (
  <div className="dine-in-stats">
    <div className="dine-in-stats__card">
      <span className="dine-in-stats__value dine-in-stats__value--active">
        {stats.activeNow}
      </span>
      <span className="dine-in-stats__label">Active now</span>
    </div>

    <div className="dine-in-stats__card">
      <span
        className={`dine-in-stats__value ${
          stats.needsAction > 0 ? "dine-in-stats__value--attention" : ""
        }`}
      >
        {stats.needsAction}
      </span>
      <span className="dine-in-stats__label">Needs action</span>
    </div>

    <div className="dine-in-stats__card">
      <span className="dine-in-stats__value dine-in-stats__value--money">
        ₹{Math.round(stats.runningTotal).toLocaleString("en-IN")}
      </span>
      <span className="dine-in-stats__label">Running total</span>
    </div>
  </div>
);

export default DineInBoardStats;
